<template lang="pug">
  main
    NavBarInventario
    Loader(v-show="isLoading")
    section.section(v-show="!isLoading")
      .container
        .columns
          .column.is-half.is-offset-one-quarter.has-text-centered
            h1.is-size-3 Búsqueda de Salidas
              | 
              router-link.a.button.is-black.is-rounded.is-medium(to="/Inventario")
                i.fas.fa-times
            br
        .columns
          .column.is-12-desktop.is-3-tablet.has-text-centered
            tabs(animation='slide' :only-fade='false' @click="ocultarData")
              tab-pane(label='Número Salida' selected='') 
                .columns.has-text-left
                  .column.is-4
                    | Escribe un número de salida válido.
                .columns
                  .column.is-5
                    typeahead(:options="salidas" :optionSelect="salidaSelected" :tema="tema" v-model="query_salida")
                  .column.is-offset-3.is-4
                    .field
                      .control
                        input.input.is-primary(
                          type='text', 
                          placeholder='Buscar: | Serie | Marca',
                          v-model="query_filtro",
                        )
              tab-pane(label='Fecha')
                .columns.has-text-left
                  .column.is-3-desktop.is-3-tablet
                    | Seleccione una fecha de Salida.
                    .field
                      .control
                        flat-pickr(
                          v-model='date'
                          :config="config"
                          class="input"
                        )

              tab-pane(label='Entrega')
                .columns.has-text-left
                  .column.is-3
                    | Escribe un usuario.
                .columns
                  .column.is-5
                    typeahead(:options="usuarios" :optionSelect="usuarioSelectedR" :tema="tema" v-model="query_usuarioE")
                  .column.is-offset-3.is-4
                    .field
                      .control
                        input.input.is-primary(
                          type='text', 
                          placeholder='Buscar: | Serie | Marca',
                          v-model="query_filtro",
                        )
              tab-pane(label='Recibe')
                .columns.has-text-left
                  .column.is-3
                    | Escribe un usuario.
                .columns
                  .column.is-3
                    typeahead(:options="usuarios" :optionSelect="usuarioSelectedE" :tema="tema" v-model="query_usuarioR")
              tab-pane(label='Ubicación')
                .columns.has-text-left
                  .column.is-5
                    | Seleccione una ubicación.
                    .select
                      select(v-model="ubicacionSelected")
                        option(v-for="u in ubicaciones" :key="u.id") {{ u.nombre}}
                  .column.is-offset-3.is-4
                    .field
                      .control
                        input.input.is-primary(
                          type='text', 
                          placeholder='Buscar: | Serie | Marca',
                          v-model="query_filtro",
                        )
        .columns
          .column.is-12.has-text-centered(v-show="isVisible_textResult")
            .notification
              button.delete
              strong {{ textResult }}
        .columns
          .column.is-12.has-text-centered(v-show="hayDatos")
            .table-responsive
              table.table.is-striped.is-fullwidth
                thead
                  tr
                    th #
                    th Categoría(s)
                    th Descripción
                    th Ubicación
                    th.is-3 Entrega
                    th.is-3 Resguarda
                    th Orden Compra
                tbody
                  tr(v-for="(data, index) in articulosShow" :key="data.id")
                    td {{ index + 1 }}
                    td(v-if="data.subcategoria")
                      .control
                        .tags.has-addons
                          span.tag.is-black
                            i.fas.fa-tag
                            | &nbsp {{ data.categoria}}
                          span.tag.is-warning {{ data.subcategoria}}
                    td
                      p.is-size-6
                        b Serie: &nbsp
                        | {{ data.serie }}
                      p.is-size-6
                        .control
                          .tags.has-addons
                            span.tag.is-info
                              | {{ data.marca }}
                            span.tag.is-black
                              | {{ data.modelo}}
                    td(v-html="getUbicacion(data.ubicacion, data.oficina)")
                    td {{ data.ingresa }}
                    td {{ data.resguardo }}
                    td {{ data.ordenCompra }}
          .columns.column-blanco
</template>

<script>
  import Loader from '../shared/Loader.vue'
  import HeaderInventario from './layout/HeaderInventario.vue'
  import NavBarInventario from './layout/NavBarInventario.vue'
  import { mapState } from 'vuex'
  import flatPickr from 'vue-flatpickr-component'
  import 'flatpickr/dist/flatpickr.css'
  import { Spanish } from "flatpickr/dist/l10n/es.js"
  import { Tabs, TabPane } from 'vue-bulma-tabs'
  import Typeahead from '@/components/inventario_Componentes/Typeahead.vue'
  import InventarioServices from '../../services/inventario/inventario'
  import usuariosServices from '../../services/usuarios/usuarios'

  export default {
    name: 'BusquedaSalidas',
    components: { Loader, NavBarInventario, HeaderInventario, flatPickr, Tabs, TabPane, Typeahead },
    data() {
      return {
        isLoading: true,
        articulos: [],
        articulosSelect: [],
        articulosShow: [],
        hayDatos: false,
        date: new Date(),
        config: {
          wrap: true, // set wrap to true only when using 'input-group'
          altFormat: 'Y-m-d',
          altInput: true,
          dateFormat: 'Y-m-d',
          locale: Spanish, // locale for this instance only          
        },
        tema: '',
        salidas: [],
        salidaSelected: {},
        query_salida: {},
        query_filtro: '',
        usuarios: [],
        usuarioSelectedR: {},
        query_usuarioR: {},
        usuarioSelectedE: {},
        query_usuarioE: {},
        ubicaciones: [
          { id: 'IRGE', nombre: 'IRGE'},
          { id: 'TPA', nombre: 'TPA'},
          { id: 'EB00', nombre: 'EB00'},
          { id: 'EB01', nombre: 'EB01'},
          { id: 'EB02', nombre: 'EB02'},
          { id: 'EB03', nombre: 'EB03'},
          { id: 'EB04', nombre: 'EB04'},
          { id: 'ERM', nombre: 'ERM'},
          { id: 'LPGD', nombre: 'Ducto'},
          { id: 'CORP', nombre: 'Corporativo'}
        ],
        ubicacionSelected: '',
        articulos_query: [],
        hayDatos: false,
        textResult: '',
        isVisible_textResult: false,
      }
    },
    watch: {
      query_salida(newValue, oldValue) {
        this.isLoading = true
        this.buscarDatos_Salida(this.query_salida)
      },
      query_usuarioE(newValue, oldValue) {
        this.buscarSalida_Usuarios(this.query_usuarioE.id,'E')
      },
      query_usuarioR(newValue, oldValue) {
        this.buscarSalida_Usuarios(this.query_usuarioR.id,'R')
      },
      ubicacionSelected(newValue, oldValue) {
        this.buscarSalida_Ubicacion(this.ubicacionSelected)
      },
      date(newValue, oldValue) {
        this.isLoading = true
        this.buscarSalida_Fecha()
      },
      query_filtro(){ 
        console.log(this.query_filtro)
        const artFilter = this.articulos_query.filter( arts => { 
        return `${arts.serie} ${arts.marca}`.toUpperCase().includes(this.query_filtro)
      }) 
      console.log(artFilter)
      this.articulosShow = artFilter
      this.textResult=`Se encontraron ${this.articulosShow.length} artículos.`
      },
    },
    methods: {
      iniciarComponente() {
        this.buscarSalidas()
      },
      buscarSalidas() {
        InventarioServices.getSalidas()
          .then( res => {
            console.log(res)
            if (res.length > 0) {
              
              res.forEach(element => {
                let tipoObj = {}
                tipoObj = {
                  id: element.id,
                  text: `${element.id}`
                }
                this.salidas.push(tipoObj)
              })
              this.isLoading = false
              this.buscarUsuarios()
            }
          })
      },
      buscarUsuarios () {
        usuariosServices.getUsuarios()
          .then( res => {
            console.log(res)
            if (res.length > 0) {
              
              res.forEach(element => {
                let tipoObj = {}
                tipoObj = {
                  id: element.id,
                  text: `${element.nombre}`
                }
                this.usuarios.push(tipoObj)
              })
            }
          })
      },
      buscarDatos_Salida(query) {
        console.log(`Buscando datos de la salida ${query.id}`)
        InventarioServices.getItemsSalida(query.id)
          .then( res => {
            if (res.length > 0) {
              this.hayDatos = true
              this.articulos_query = res
              this.articulosShow = this.articulos_query
              this.isLoading = false
              this.textResult = `Se encontraron ${res.length} artículos.`
              this.isVisible_textResult = true
            } else {
              this.textResult = `No se encontraron artículos para ésta búsqueda.`
              this.isVisible_textResult = true
              this.hayDatos = false
              this.isLoading = false
            }
          })
      },
      buscarSalida_Fecha(){
        console.log('Buscar por fecha')
        InventarioServices.getSalidas_Fecha(this.date)
          .then( res => {
            if (res.length > 0) {
              this.hayDatos = true
              this.articulos_query = res
              this.articulosShow = this.articulos_query
              this.textResult = `Se encontraron ${res.length} artículos.`
              this.isVisible_textResult = true
              this.isLoading = false
            } else {
              this.textResult = `No se encontraron artículos para ésta búsqueda.`
              this.isVisible_textResult = true
              this.hayDatos = false
              this.isLoading = false
            }
          })
      },
      buscarSalida_Usuarios(id, tipo){
        console.log('Buscar por Usuario')
        InventarioServices.getSalidas_Usuario(id, tipo)
          .then( res => {
            if (res.length > 0) {
              this.hayDatos = true
              this.articulos_query = res
              this.articulosShow = this.articulos_query
              this.textResult = `Se encontraron ${res.length} artículos.`
              this.isVisible_textResult = true
              this.isLoading = false
            } else {
              this.textResult = `No se encontraron artículos para ésta búsqueda.`
              this.isVisible_textResult = true
              this.hayDatos = false
              this.isLoading = false
            }
          })
      },
      buscarSalida_Ubicacion(ubi){
        console.log('Buscar por Usuario')
        InventarioServices.getSalidas_Ubicacion(ubi)
          .then( res => {
            if (res.length > 0) {
              this.hayDatos = true
              this.articulos_query = res
              this.articulosShow = this.articulos_query
              this.textResult = `Se encontraron ${res.length} artículos.`
              this.isVisible_textResult = true
              this.isLoading = false
            } else {
              this.textResult = `No se encontraron artículos para ésta búsqueda.`
              this.isVisible_textResult = true
              this.hayDatos = false
              this.isLoading = false
            }
          })
      },
      getUbicacion (ubi, ofi) {
        let oficinaStr = ''
        switch (ofi) {
          case 'TPA-ALM':
            oficinaStr = 'Almacen'
            break
          case 'TPA-ALS':
            oficinaStr = 'Almacen Sist.'
            break
          case 'TPA-ADM':
            oficinaStr = 'Of. Admin.'
            break
          case 'TPA-CC':
            oficinaStr = 'Cuarto de Control'
            break
          case 'TPA-SERV':
            oficinaStr = 'Servidores'
            break;
          case 'TPA-IO':
            oficinaStr = 'Cuarto de IOS'
            break;
          case 'TPA-FAC':
            oficinaStr = 'Facturación'
            break
          case 'TPA-BAS':
            oficinaStr = 'Báscula'
            break
          case 'TPA-GER':
            oficinaStr = 'Gerencia'
            break
          case 'TPA-MUE':
            oficinaStr = 'Muelle'
            break
          case 'TPA-MANT':
            oficinaStr = 'Of. de Mntto.'
            break;
          case 'TPA-TALL':
            oficinaStr = 'Taller de Mntto.'
            break;
          case 'TPA-SEG':
            oficinaStr = 'Of. Seguridad'
            break;
          case 'TPA-PROP':
            oficinaStr = 'Of. Propangol'
            break;
          case 'TPA-MOV':
            oficinaStr = 'Of. Movenergy'
            break;
          case 'TPA-SJ':
            oficinaStr = 'Sala de Juntas'
            break;
          case 'TPA-ACC':
            oficinaStr = 'Accesos'
            break;
          case 'TPA-VIG':
            oficinaStr = 'Vigilancia'
            break;
          case 'TPA-ESF':
            oficinaStr = 'Esféricos'
            break;
          case 'TPA-LLEN':
            oficinaStr = 'Llenaderas'
            break;
          case 'TPA-SJ2':
            oficinaStr = 'Sala de Juntas 2'
            break;
          case 'TPA-REC':
            oficinaStr = 'Recepción'
            break;
          case 'IRGE-ADM':
            oficinaStr = 'Of. Admin.'
            break
          case 'IRGE-ALM':
            oficinaStr = 'Almacen'
            break
          case 'IRGE-CC':
            oficinaStr = 'Cuarto de Control'
            break
          case 'IRGE-FAC':
            oficinaStr = 'Facturación'
            break
          case 'IRGE-BAS':
            oficinaStr = 'Báscula'
            break
          case 'IRGE-GER':
            oficinaStr = 'Gerencia'
            break
          case 'IRGE-GADM':
            oficinaStr = 'Gerencia Admin.'
            break
          case 'IRGE-SJ':
            oficinaStr = 'Sala de Juntas'
            break
          case 'IRGE-SEG':
            oficinaStr = 'Seguridad'
            break
          case 'IRGE-IOS':
            oficinaStr = 'Cuarto de IOS'
            break
          case 'IRGE-PEM':
            oficinaStr = 'PEMEX'
            break
          case 'IRGE-ACC':
            oficinaStr = 'Accesos'
            break
          case 'IRGE-VIG':
            oficinaStr = 'Vigilancia'
            break
          case 'IRGE-CE':
            oficinaStr = 'Cuarto Eléctrico'
            break
          case 'IRGE-REC':
            oficinaStr = 'Recepción'
            break
          case 'IRGE-OP':
            oficinaStr = 'Operación'
            break
          case 'IRGE-CCP':
            oficinaStr = 'Cuarto Control Plus'
            break
          case 'IRGE-VP':
            oficinaStr = '23 Puntos'
            break
          case 'IRGE-MOV':
            oficinaStr = 'Movenergy'
            break
          case 'IRGE-VIC':
            oficinaStr = 'Vigilancia CUSAEM'
            break
          case 'EB04-CC':
            oficinaStr = 'Cuarto de Control'
            break
          case 'EB04-ALG':
            oficinaStr = 'Almacén GIA'
            break
          case 'EB04-ADM':
            oficinaStr = 'Of. Admin.'
            break
          case 'EB04-GER':
            oficinaStr = 'Gerencia'
            break
          case 'EB04-SIS':
            oficinaStr = 'Sistemas'
            break
          case 'EB04-INS':
            oficinaStr = 'Instrumentación'
            break
          case 'EB04-VIG':
            oficinaStr = 'Vigilancia'
            break
          case 'EB04-SG':
              oficinaStr = 'Sala de Juntas'
              break
          case 'EB04-TIA':
            oficinaStr = 'Taller Inst/Aut'
            break
          case 'EB03-CC':
            oficinaStr = 'Cuarto de Control'
            break
          case 'EB03-ADM':
            oficinaStr = 'Of. Admin.'
            break
          case 'EB03-VIG':
            oficinaStr = 'Vigilancia'
            break
          case 'EB02-CC':
            oficinaStr = 'Cuarto de Control'
            break
          case 'EB02-ADM':
            oficinaStr = 'Of. Admin.'
            break
          case 'EB02-VIG':
            oficinaStr = 'Vigilancia'
            break
          case 'EB01-CC':
            oficinaStr = 'Cuarto de Control'
            break
          case 'EB01-ADM':
            oficinaStr = 'Of. Admin.'
            break
          case 'EB01-VIG':
            oficinaStr = 'Vigilancia'
            break
          case 'EB00-CC':
            oficinaStr = 'Cuarto de Control'
            break
          case 'EB00-ADM':
            oficinaStr = 'Of. Admin.'
            break
          case 'EB00-VIG':
            oficinaStr = 'Vigilancia'
            break
          case 'ERM-CC':
            oficinaStr = 'Cuarto de Control'
            break
          case 'ERM-ADM':
            oficinaStr = 'Of. Admin.'
            break
          case 'ERM-VIG':
            oficinaStr = 'Vigilancia'
            break
          case 'VALV-ADM':
            oficinaStr = 'Gabinete'
            break
          case 'CORP-DIR':
            oficinaStr = 'Dirección'
            break
          case 'CORP-GG':
            oficinaStr = 'Gerencia General'
            break
          case 'CORP-GC':
            oficinaStr = 'Contraloría'
            break
          case 'CORP-C':
            oficinaStr = 'Contabilidad'
            break
          case 'CORP-CP':
            oficinaStr = 'Cuentas por Pagar'
            break
          case 'CORP-F':
            oficinaStr = 'Fiscal'
            break
          case 'CORP-SA':
            oficinaStr = 'Seguimiento Ambiental'
            break
          case 'CORP-GR':
            oficinaStr = 'Regulación'
            break
          case 'CORP-ALM':
            oficinaStr = 'Almacén'
            break
          case 'CORP-ALG':
            oficinaStr = 'Almacén GIA'
            break
          case 'CORP-GIS':
            oficinaStr = 'Gerencia Inst. y Sist.'
            break
          case 'CORP-SIT':
            oficinaStr = 'Site'
            break
          case 'CORP-RH':
            oficinaStr = 'Recursos Humanos'
            break
          case 'CORP-LEG':
            oficinaStr = 'Legal'
            break
          case 'CORP-REC':
            oficinaStr = 'Recepción'
            break
          case 'LPGD-V1':
            oficinaStr = 'Válvula 1'
            break
          case 'LPGD-V2':
            oficinaStr = 'Válvula 2'
            break
          case 'LPGD-V3':
            oficinaStr = 'Válvula 3'
            break
          case 'LPGD-V4':
            oficinaStr = 'Válvula 4'
            break
          case 'LPGD-V5':
            oficinaStr = 'Válvula 5'
            break
          case 'LPGD-V6':
            oficinaStr = 'Válvula 6'
            break
          case 'LPGD-V7':
            oficinaStr = 'Válvula 7'
            break
          case 'LPGD-V8':
            oficinaStr = 'Válvula 8'
            break
          case 'LPGD-V9':
            oficinaStr = 'Válvula 9'
            break
          case 'LPGD-V10':
            oficinaStr = 'Válvula 10'
            break
          case 'LPGD-V11':
            oficinaStr = 'Válvula 11'
            break
          case 'LPGD-V12':
            oficinaStr = 'Válvula 12'
            break
          case 'LPGD-V13':
            oficinaStr = 'Válvula 13'
            break
          case 'LPGD-V14':
            oficinaStr = 'Válvula 14'
            break
          case 'LPGD-V15':
            oficinaStr = 'Válvula 15'
            break
          case 'LPGD-V16':
            oficinaStr = 'Válvula 16'
            break
          case 'LPGD-V17':
            oficinaStr = 'Válvula 17'
            break
          case 'LPGD-V18':
            oficinaStr = 'Válvula 18'
            break
          case 'LPGD-V19':
            oficinaStr = 'Válvula 19'
            break
          case 'LPGD-V20':
            oficinaStr = 'Válvula 20'
            break
          case 'LPGD-V21':
            oficinaStr = 'Válvula 21'
            break
          case 'LPGD-V22':
            oficinaStr = 'Válvula 22'
            break
          case 'LPGD-V23':
            oficinaStr = 'Válvula 23'
            break
          case 'LPGD-V24':
            oficinaStr = 'Válvula 24'
            break
          case 'LPGD-V25':
            oficinaStr = 'Válvula 25'
            break
          case 'LPGD-V26':
            oficinaStr = 'Válvula 26'
            break
          case 'LPGD-V1B':
            oficinaStr = 'Válvula 1 BIS'
            break
          case 'LPGD-V2B':
            oficinaStr = 'Válvula 2 BIS'
            break
          case 'LPGD-V3B':
            oficinaStr = 'Válvula 3 BIS'
            break
          case 'LPGD-V4B':
            oficinaStr = 'Válvula 4 BIS'
            break
          case 'LPGD-V5B':
            oficinaStr = 'Válvula 5 BIS'
            break
          case 'LPGD-INT':
            oficinaStr = 'Interconexión'
            break
          case 'TPA-RV':
            oficinaStr = 'Recuperador de vapores'
            break
          case 'TPA-PM':
            oficinaStr = 'Paquete de Medición'
            break
          case 'TPA-BP':
            oficinaStr = 'Bombas de Proceso'
            break
          case 'TPA-SISV':
            oficinaStr = 'Sistema Vickers'
            break
          case 'TPA-SCI':
            oficinaStr = 'Sist. Contra Incendio'
            break
          case 'TPA-CB':
            oficinaStr = 'Cuarto de Baterias'
            break
          case 'EB00-BP':
            oficinaStr = 'Bombas de Proceso'
            break
          case 'EB00-CB':
            oficinaStr = 'Cuarto de Baterias'
            break
          case 'EB00-PM':
            oficinaStr = 'Patín de Medición'
            break
          case 'EB00-TD':
            oficinaStr = 'Trampa de Diablos'
            break
          case 'EB00-TR':
            oficinaStr = 'Tren de Regulación'
            break
          case 'ERM-PM':
            oficinaStr = 'Patín de Medición'
            break
          case 'ERM-SAL':
            oficinaStr = 'Salida IRGE'
            break
          case 'ERM-TD':
            oficinaStr = 'Trampa de Diablos'
            break
          case 'ERM-TP':
            oficinaStr = 'Tanque Pulmón'
            break
          case 'ERM-TPRG':
            oficinaStr = 'Tanque de Purga'
            break
          case 'ERM-TR':
            oficinaStr = 'Tren de Regulación'
            break
          case 'EB04-BP':
            oficinaStr = 'Bombas de Proceso'
            break
          case 'EB04-CAB':
            oficinaStr = 'Cabezales'
            break
          case 'EB04-CB':
            oficinaStr = 'Cobertizo de Bombas'
            break
          case 'EB04-COC':
            oficinaStr = 'Cocina'
            break
          case 'EB04-CTE':
            oficinaStr = 'Cuarto Eléctrico'
            break
          case 'EB04-GEN':
            oficinaStr = 'Generadores'
            break
          case 'EB04-PM':
            oficinaStr = 'Patín de Medición'
            break
          case 'EB04-RP':
            oficinaStr = 'Residuos Peligrosos'
            break
          case 'EB04-TALL':
            oficinaStr = 'Taller y Almacén'
            break
          case 'EB04-TD':
            oficinaStr = 'Trampa de Diablos'
            break
          case 'EB04-TORG':
            oficinaStr = 'Tanque de Purga'
            break
          case 'EB04-TR':
            oficinaStr = 'Tren de Regulación'
            break
          case 'EB04-TRA':
            oficinaStr = 'Transformador'
            break
          case 'IRGE-BOM':
            oficinaStr = 'Bombas LPG'
            break
          case 'IRGE-BP':
            oficinaStr = 'Bombas de Proceso'
            break
          case 'IRGE-CB':
            oficinaStr = 'Cuarto de Bombas'
            break
          case 'IRGE-CCM':
            oficinaStr = 'CCM'
            break
          case 'IRGE-CI':
            oficinaStr = 'Red C.I.'
            break
          case 'IRGE-COMP':
            oficinaStr = 'Area de Compresores'
            break
          case 'IRGE-CONT':
            oficinaStr = 'Contabilidad'
            break
          case 'IRGE-CUB':
            oficinaStr = 'Cubeta'
            break
          case 'IRGE-ESF':
            oficinaStr = 'Esferas'
            break
          case 'IRGE-LLEN':
            oficinaStr = 'Llenaderas'
            break
          case 'IRGE-MANT':
            oficinaStr = 'Of. Mantenimiento'
            break
          case 'IRGE-PROP':
            oficinaStr = 'Of. Propangol'
            break
          case 'IRGE-TA':
            oficinaStr = 'Tanque de Agua'
            break
          case 'IRGE-TD':
            oficinaStr = 'Trampa de Diablos'
            break
          case 'IRGE-TP':
            oficinaStr = 'Tanque Pulmón'
            break
          case 'IRGE-TR':
            oficinaStr = 'Tren de Regulación'
            break
          case 'IRGE-TRA':
            oficinaStr = 'Area de Trasiegos'
            break
        }
        return `<div class="control">
          <div class="tags has-addons">
            <span class="tag is-dark"><i class="fas fa-map-pin"></i>&nbsp${ubi}</span>
            <span class="tag is-primary">${oficinaStr}</span>
          </div>
        </div>`
      },
      ocultarData () {
        console.log('ocultar data')
        this.hayDatos = false
      }
    },
    created () {
      this.iniciarComponente()
      console.log(this.tabs)
    },
    computed: {
    ...mapState(['userLogin'])
    }
  }
  
</script>

<style lang="css" scoped>
  .column-blanco {
    padding-bottom: 100px;
  }
</style>


// WEBPACK FOOTER //
// src/components/inventario_Componentes/BusquedaSalidas.vue